import { LocalStorageKeys } from "../../../constant/LocalStorageKeys";
import localStorageServices from "../../../services/LocalStorage";
import {
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  UPDATE_USER_INFO,
} from "../../constants/actions";

const initialState = {
  loading: false,
  loginSucces: false,
  token:localStorageServices.getItem(LocalStorageKeys.userToken)||"",
  userInfo:localStorageServices.getItem(LocalStorageKeys.userInfo)||null,
  error: false,
};


const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loginSucces: true,
        token: action.payload.token,
        userInfo: action.payload.user_info,
      };
      case UPDATE_USER_INFO:
        return {
          ...state,
          userInfo: {
            ...state.userInfo,
            ...action.payload, // Merge existing and new data
          },
        };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case LOGOUT:
      return {
        loading: false,
        loginSucces: false,
        token: "",
        userInfo: "",
        error: "",
      };
    default:
      return state;
  }
};

export default userReducer;
